<!--begin::Intro video (plays once, then the page splits)-->
<div class="lp-intro" [hidden]="!introVisible" [class.is-leaving]="introLeaving">
  <video #introVideo class="lp-intro__video" muted playsinline preload="auto"
         poster="/assets/landing/img/intro-poster.jpg" aria-label="Global Lab intro"
         (ended)="onIntroEnded()">
    <source src="/assets/landing/video/intro.webm" type="video/webm">
    <!-- Il browser prova prima WebM e poi MP4: si rinuncia solo se fallisce l'ultima sorgente. -->
    <source src="/assets/landing/video/intro.mp4" type="video/mp4" (error)="showSplit(false)">
  </video>
  <button type="button" class="lp-intro__skip" (click)="showSplit(true)">Skip intro</button>
</div>
<!--end::Intro video-->

<!--begin::Home: two areas-->
<div class="lp-home" [class.is-entering]="entering">

  <header class="lp-topbar">
    <img class="lp-topbar__logo" src="/assets/landing/img/globallab-logo.png" alt="Global Lab" width="800" height="173">
    <nav class="lp-topbar__nav" aria-label="Main">
      <a href="#gateway" (click)="scrollTo($event, 'gateway')">Gateway</a>
      <a href="#regulators" (click)="scrollTo($event, 'regulators')">Ecosystem for Regulators</a>
      <a href="#contact" (click)="scrollTo($event, 'contact')">Contact</a>
      <button type="button" class="lp-pill" (click)="playIntro()">
        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="6 4 20 12 6 20 6 4"/></svg>
        Play intro
      </button>
    </nav>
  </header>

  <main class="lp-split">

    <!--begin::Left: Gateway (Global Lab team)-->
    <section class="lp-area lp-area--gateway" id="gateway" aria-labelledby="gwTitle">
      <div class="lp-area__head">
        <span class="lp-eyebrow">FOR GLOBAL LAB AND CLIENTS</span>
        <h1 class="visually-hidden" id="gwTitle">Gateway</h1>
        <img class="lp-gateway-logo" src="/assets/landing/img/gateway-logo.png" alt="Gateway" width="1057" height="326">
        <p class="lp-lead">The innovative ERP of gaming testing and audit. Clients, requests, proposals, projects and certificates in one place.</p>
      </div>

      <div class="lp-tiles">
        <a class="lp-tile" routerLink="/app/clients">
          <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M3 20c.6-3.4 3-5.4 6-5.4s5.4 2 6 5.4"/><circle cx="17.5" cy="9" r="2.4"/><path d="M16 14.6c2.5.2 4.3 1.9 4.9 4.6"/></svg>
          <strong>Clients</strong>
          <span>Licensees, manufacturers, operators</span>
        </a>
        <a class="lp-tile" routerLink="/app/requests">
          <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16v11H8l-4 4z"/><path d="M8 9h8M8 12h5"/></svg>
          <strong>Requests</strong>
          <span>New testing and audit requests</span>
        </a>
        <a class="lp-tile" routerLink="/app/proposals">
          <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h9l4 4v14H6z"/><path d="M14 3v5h5M9 13h7M9 17h5"/></svg>
          <strong>Proposals</strong>
          <span>Quotes and framework agreements</span>
        </a>
        <a class="lp-tile" routerLink="/app/projects">
          <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M8 13h3M8 16h6"/></svg>
          <strong>Projects</strong>
          <span>Testing, certificates, reports</span>
        </a>
      </div>

      <div class="lp-area__actions">
        <a class="lp-btn lp-btn--dark" routerLink="/app">Sign in to Gateway</a>
        <span class="lp-version">v. 3.0.00</span>
      </div>
    </section>
    <!--end::Left-->

    <!--begin::Right: Ecosystem for Regulators-->
    <section class="lp-area lp-area--regulators" id="regulators" aria-labelledby="regTitle">
      <div class="lp-area__head">
        <span class="lp-eyebrow">FOR REGULATORS</span>
        <h2 class="lp-area__title" id="regTitle">Ecosystem for Regulators</h2>
        <p class="lp-lead">One secure space where regulators follow the compliance of their licensees, with Global Lab as independent testing laboratory and auditor.</p>
      </div>

      <!-- I moduli portano al login finché non esiste un'area dedicata ai regulator. -->
      <ol class="lp-modules">
        <li><a class="lp-module" routerLink="/login">
          <span class="lp-module__num">01</span>
          <strong>Website pre-compliance</strong>
          <span>Licensees check their sites against your checklist. You monitor every operator in real time.</span>
        </a></li>
        <li><a class="lp-module" routerLink="/login">
          <span class="lp-module__num">02</span>
          <strong>Regulatory Advisory Notices</strong>
          <span>Global Lab flags potential risks on certifications before they reach the market.</span>
        </a></li>
        <li><a class="lp-module" routerLink="/login">
          <span class="lp-module__num">03</span>
          <strong>Certification register</strong>
          <span>Certificates and test reports by licensee, game and system.</span>
        </a></li>
        <li><a class="lp-module" routerLink="/login">
          <span class="lp-module__num">04</span>
          <strong>KYC and audit checklists</strong>
          <span>Audit results confirmed by Global Lab as auditor, ready for your review.</span>
        </a></li>
      </ol>

      <div class="lp-area__actions">
        <a class="lp-btn lp-btn--accent" routerLink="/login">Regulator access</a>
      </div>
    </section>
    <!--end::Right-->
  </main>

  <footer class="lp-footer" id="contact">
    <span>Copyright © 2020-2026 Global Lab Ltd. All rights reserved.</span>
    <span>A big problem must be broken down into many small problems.</span>
  </footer>
</div>
<!--end::Home-->
